/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./listRecords.defs.js";
export { main as default } from "./listRecords.defs.js";
